import { AlertModal } from "../../.."
import { observer } from "mobx-react-lite"
import { store } from "../../../stores/Store"
import TruncText from "../../../misc/TruncText"
import InlineMenu from "../../../misc/InlineMenu"
import IsAllowed from "../../../models/Permissions"
import DeleteForm from "../../form/case/DeleteForm"
import { Button, CircularProgress } from "@mui/material"
import UpdatePasswordForm from "../../form/admin/UserPasswordUpdateForm"
import { UserCreateForm, UserUpdateForm } from "../../form/admin/UserForms"
import React from "react"
import { Icons } from "../../../misc/Icons"
import Ajax from "../../../Ajax"
import UserPasswordUpdateInvite from "../../form/admin/UserPasswordUpdateInvite"


interface AccountUsersProps {
    account: any;
}


export default observer(function AccountUsers ({account}: AccountUsersProps) {

    const users = account?.childrenObjects.filter((node: any) => {
        if (node.typeName !== "Aora.Platform.Data.UserNode") {
            return false
        }

        // Hide 'System user'
        // if (!node.logon && node.label?.includes("System")) {
        //     return false
        // }

        return true
    })

    return (
        <div className="tool-section" style={{maxWidth: "700px"}}>
            <h3>Users</h3>
            
            <div className="tool-table">
                {users?.map((user, i) => <UserDetail key={i} user={user} />)}

                {!users?.length ? (
                    <small>This account has no users.</small>
                ) : null}
            </div>

            {IsAllowed("User", "CREATE") ? (
                <Button
                    color="secondary"
                    variant="contained"
                    className="btn btn-sm"
                    disabled={!!store.AppStore.sessionState}
                    onClick={() => {
                        AlertModal({body: (
                            <UserCreateForm
                                account={account} 
                                onSuccess={() => {
                                    store.ToolStore.getAccount(account.uid)
                                    store.AlertStore.Close()
                            }} />
                        )})
                    }}>
                    Create User
                </Button>
            ) : null}
        </div>
    )
})

function UserDetail ({user}) {

    const [refreshing, setRefreshing] = React.useState(false)

    return (
        <p style={{height: "25px", alignItems: "center", display: "grid", gridTemplateColumns: "35px auto 100px 140px 140px"}}>
            <InlineMenu
                opener={refreshing ? <CircularProgress color="info" style={{width: "12px", height: "12px"}} /> : undefined}
                disabled={!!store.AppStore.sessionState || refreshing}
                title={store.NodeStore.getDisplayType(user) + " options"}
                menuItems={[
                    {
                        label: `Send password update email`,
                        action: () => AlertModal({body: <UserPasswordUpdateInvite userUid={user.uid} />, width: "450px"})
                    },
                    {
                        label: "Update password",
                        action: () => AlertModal({body: <UpdatePasswordForm user={user} />, size: "xs"})
                    },
                    {
                        label: "Edit user",
                        action: () => AlertModal({body: <UserUpdateForm requestFullUser user={user} onSuccess={async () => {
                            store.AlertStore.Close()
                            setRefreshing(true)
                            await store.ToolStore.getAccount()
                            setRefreshing(false)
                        }} />}),
                        hidden: !IsAllowed(user, "UPDATE")
                    },
                    {
                        label: "Delete user",
                        action: () => AlertModal({body: <DeleteForm node={user} onSuccess={async () => {
                            store.AlertStore.Close()
                            setRefreshing(true)
                            await store.ToolStore.getAccount()
                            setRefreshing(false)
                        }} />}),
                        hidden: !IsAllowed(user, "DELETE")
                    },
            ]} />
            
            <TruncText text={user.label} style={{minWidth: "100px"}} />
            
            <TruncText text={user.uid} />
        </p>
    )
}